import styled from 'styled-components';

export const KeypointOverlayDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
`;

export const KeypointDot = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  background: #ff3b3b;
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.25);
  transform: translate(-50%, -50%);
  pointer-events: auto;
`;
